// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"LoadingSpinner_spinnerWrapper__V8F1M"};